<div class="hierarchy-scroller">
    <ng-container *ngIf="service.groupsHierarchy$ | async as hierarchy">
        <app-group-tree [showButton]="showButton" [node]="node" *ngFor="let node of hierarchy.rawData()"></app-group-tree>
    </ng-container>
</div>